const INITIAL_STATE = {}

export const saveUserTime = time => ({ type: 'SAVE_USER_TIME', time })

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_USER_NAME': {
      return {
        ...state,
        name: action.name
      }
    }

    case 'SAVE_USER_TIME': {
      return {
        ...state,
        time: action.time
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/user/Reducer.js